import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const WebhooklogsAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		payload: yup.string().nullable().label("Payload"),
		statuscode: yup.number().nullable().label("Statuscode"),
		errormessage: yup.string().nullable().label("Errormessage"),
		receivedat: yup.string().nullable().label("Receivedat"),
		processedat: yup.string().nullable().label("Processedat")
	});
	
	//form default values
	const formDefaultValues = {
		payload: '', 
		statuscode: '', 
		errormessage: '', 
		receivedat: "(getutcdate())", 
		processedat: new Date(), 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/webhooklogs`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="WebhooklogsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Webhooklog"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Payload 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="payload"  onChange={formik.handleChange}  value={formik.values.payload}   label="Payload" type="text" placeholder="Enter Payload"        className={inputClassName(formik?.errors?.payload)} />
                                                <ErrorMessage name="payload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Statuscode 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="statuscode"  onChange={formik.handleChange}  value={formik.values.statuscode}   label="Statuscode" type="number" placeholder="Enter Statuscode"  min={0}  step="any"    className={inputClassName(formik?.errors?.statuscode)} />
                                                <ErrorMessage name="statuscode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Errormessage 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="errormessage"  onChange={formik.handleChange}  value={formik.values.errormessage}   label="Errormessage" type="text" placeholder="Enter Errormessage"        className={inputClassName(formik?.errors?.errormessage)} />
                                                <ErrorMessage name="errormessage" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Receivedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="receivedat" value={formik.values.receivedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.receivedat)}        />
                                                <ErrorMessage name="receivedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Processedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="processedat" value={formik.values.processedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.processedat)}        />
                                                <ErrorMessage name="processedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
WebhooklogsAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'webhooklogs',
	apiPath: 'webhooklogs/add',
	routeName: 'webhooklogsadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default WebhooklogsAddPage;
